import {Component, OnInit} from '@angular/core';

import {SelectItem} from 'primeng/primeng';
import {Site} from "../../api/model/site";
import {ActivatedRoute} from "@angular/router";
import {AwsService} from "../aws.service";
import {Router} from "@angular/router";

import * as _ from 'lodash';
import {Message} from "primeng/components/common/api";

@Component({
    template: require('./site-form.component.pug'),
    styles: [require('./site-form.component.css')]
})
export class SiteFormComponent implements OnInit {
    msgs: Message[] = [];

    model: Site = {};

    lang: SelectItem[] = [
        {label: 'Español', value: 'es'},
        {label: 'Inglés', value: 'en'},
    ];

    //uploadedFiles: any[] = [];

    permalink: SelectItem[] = [
        {label: 'título-post', value: ':title/'},
        {label: 'año/mes/día/título-post', value: ':year/:month/:day/:title/'},
        {label: 'categoría1/categoría2/título-post', value: ':category/:title'},
        {label: 'tag1/tag2/título-post', value: ':tag/:title'},
        {label: 'idioma/título-post', value: ':lang/:title/'},
    ];





    photo: string;

    action: string = 'create';

    themes: SelectItem[] = [];

    subdomain: RegExp = /[\w-]+/;

    constructor(private route: ActivatedRoute, private _router: Router, private _awsService: AwsService) {
    }

    async ngOnInit() {
        let id = this.route.snapshot.paramMap.get("id");
        if (id !== "new") {
            this.model = (await this._awsService.api.sitesSiteGet({site: id})).data;
            const items = (await this._awsService.api.sitesSiteThemesGet({site: id})).data.items;
            items.map((item:any) => this.themes.push({label: item.theme, value: item.theme}));
            this.action = 'update';
        }
        const s3 = new this._awsService.AWS.S3(this._awsService.credentials);
        const params = {Bucket: 'sintesis-common', Key: 'hexo/themes.json'};
        const res = await s3.getObject(params).promise();
        const bases = JSON.parse(res.Body.toString());
        for (let base of Object.keys(bases)) {
            if (!_.find(this.themes, {value: base})) {
                this.themes.push({label: base, value: base});
            }
        }
    }

    async save() {
        this.msgs = [];
        if (!this.model.id) {
            this.msgs.push({
                severity: 'info',
                summary: 'El nombre del site es obligatorio'
            });
            return;
        }
        if (this.model.id.length < 5) {
            this.msgs.push({
                severity: 'info',
                summary: 'El nombre del site debe ser mayor o igual a 5 caracteres'
            });
            return;
        }
        if (this.action == 'create') {
            try {
                this.model = (await this._awsService.api.sitesPost({}, this.model)).data;
                console.log('created', this.model);
                this.action = 'update';
                await this._awsService.updateSites();
                this.msgs.push({
                    severity: 'info',
                    summary: 'El site ha sido creado satisfactoriamente.'
                });
                setTimeout(()=>{
                    window.location.reload();
                }, 4000);
                setTimeout(()=>{
                    this._router.navigate(['/']);
                }, 4200);
                
                
               
                

            } catch (err) {
                this.msgs.push({severity: 'error', summary: 'Error en la creación del site'});
            }
        } else {
            try {
                this.model = (await this._awsService.api.sitesSitePut({site: this.model.id}, this.model)).data;
                this.msgs.push({
                    severity: 'info',
                    summary: 'El site ha sido actualizado satisfactoriamente.'
                });
                
                setTimeout(()=>{
                    window.location.reload();
                }, 4000);
                setTimeout(()=>{
                    this._router.navigate(['/']);
                }, 4200);

            } catch (err) {
                this.msgs.push({severity: 'error', summary: 'Error en la actualización'});
            }
        }
    }

    async uploadHandler(event: any, uploader: any) {
    }
    
    async theme() {
        
    }

}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/sites/site-form.component.ts